export const INIT_TIME = '00:00:00.000';

export const suspendMonthlyPrepaymentOptions = [
  {
    id: 1,
    description: 'common_no',
  },
  {
    id: 2,
    description: 'manage_payment__yes_through',
  },
  {
    id: 3,
    description: 'manage_payment__yes_reinstate',
  },
];

export const SUSPEND_OPTIONS = {
  NO: 1,
  YES_THROUGH_MONTH: 2,
  YES_UNTIL_REINSTATE: 3,
};

export const CURRENCY_CAD = 4;

export const PAYMENT_OPTIONS = {
  MonthlyPayment: 'Monthly Prepay',
  PrePayment: 'Onetime Prepay',
};

export const PAYMENT_OPTIONS_INDEX = {
  0: 'PrePayment',
  1: 'MonthlyPayment',
};

export const INPUT_AMOUNT_REGEX = /^\d+(\.\d{0,2})?$/;
export const VALID_AMOUNT_REGEX = /^\d+(\.\d{1,2})?$/;

export const MINIMUM_DEPOSIT_AMOUNT = 100;
